import styled from 'styled-components';
import { Input } from '@prima-afp/prima-ui-elements/dist/core';
import { media } from '@prima-afp/prima-ui-elements/dist/utils/media/styledConfig';

export const InputStyled = styled(Input)`
  width: fit-content;
  margin: ${props => props.margin};
  input {
    border-width: 0px 0px 3px 0px !important;
    border-radius: 0px !important;
    border-color: var(--grayColor300) !important;

    font-family: 'FS Emeric' !important;
    font-weight: 600 !important;
    font-size: 24px !important;
    text-align: center !important;
    color: ${props => props.fontColor} !important;

    caret-color: var(--orangeColorMain) !important;
    &:focus{
      border-width: 0px 0px 3px 0px !important;
      border-radius: 0px !important;
    }
    ${media.sm`
      width: 100% !important;
    `}
    ${media.xs`
      width: 100% !important;
    `}
  }
  input + span {
    font-family: 'FS Emeric' !important;
    font-weight: 600 !important;
    font-size: 24px !important;
    text-align: center !important;
  }
`